export const BASE_URL = 'https://www.skapiec.pl';

export const MAX_INT_CONST = 2147483647;
